// Firebase Web configuration is public by design: it is delivered to every browser
// that loads the admin app. Keep server credentials out of this module.
export const adminFirebaseClientConfig = Object.freeze({
  apiKey: 'AIzaSyBQHIIoKjG_T-G-GU3SGg-AW_H-qXF7kYk',
  authDomain: 'su-guide.firebaseapp.com',
  projectId: 'su-guide',
  storageBucket: 'su-guide.firebasestorage.app',
  messagingSenderId: '1025205356770',
  appId: '1:1025205356770:web:50750087c125db006e76bb',
})

export function validateAdminFirebaseClientConfig(config = adminFirebaseClientConfig) {
  if (!config?.apiKey || !config?.authDomain || !config?.projectId || !config?.appId) return 'PUBLIC_FIREBASE_CONFIG_INVALID'
  if (config.projectId !== 'su-guide') return 'PROJECT_ID_MISMATCH'
  return null
}
